export const AND = '$AND';
export const OR = '$OR';
export const EQUAL = '$EQ';
export const NOT_EQUAL = '$NE';
export const IN = '$IN';
export const NOT_IN = '$NIN';
export const SUB_STR = '$SUBSTR';
export const ENCLOSURE = '"';
export const P_START = '(';
export const P_END = ')';
export const EQUAL_QUERY = ':';
export const NOT_EQUAL_QUERY = '!';
